﻿<mat-icon svgIcon="search" class="nav__search-icon" />
<input
  class="nav__search"
  [placeholder]="'sharedNav.globalSearch.searchPlaceholder' | transloco"
  type="text"
  [(ngModel)]="searchTerms"
  (mousedown)="showHistoryDialog()"
  #globalSearchBox
  />
<ng-template #historyDialogRef>
  <div class="global-search-dialog">
    <mat-form-field appearance="outline"
      class="nav__select">
      <mat-select
        name="category-select"
        [(ngModel)]="selectedSearchCategory"
        [compareWith]="defaultCompare"
        (selectionChange)="showResults()"
        >
        @for (category of searchCategories; track category) {
          <mat-option
            [value]="category.id"
            >
            {{ category.displayName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (!searchTerms) {
      <span matPrefix class="search-presufix-wrapper">
        <mat-icon svgIcon="search-blue" class="search-prefix-icon"></mat-icon>
      </span>
    }
    <input
      class="nav__search__dialog"
      [placeholder]="'sharedNav.globalSearch.searchIdealPlaceholder' | transloco"
      spellcheck="false"
      type="text"
      [(ngModel)]="searchTerms"
      (input)="showResults()"
      #globalSearchInput
      (keydown.enter)="updateSearchHistoryStorage();navigate()"
      [ngStyle]="{'padding-left': searchTerms ? '0.75em' : '2.25em' }"
      />
    @if (searchTerms) {
      <span class="search-presufix-wrapper">
        <mat-icon
          svgIcon="close"
          class="close-sufix-icon"
          (click)="noResults=false;searchTerms=''"
        ></mat-icon>
      </span>
    }
    @if (selectedSearchCategory === GlobalSearchCategory.Company) {
      <br>
        <idl-companies-hierarchy-toggle class="toggle-group" [formControl]="companiesFilterControl"></idl-companies-hierarchy-toggle>
      }
      <div class="border-wrapper"></div>
      @if (!searchTerms) {
        <div class="matomo_header recent-label">{{ 'sharedNav.globalSearch.recentSearches' | transloco }}</div>
        @for (searchValue of searchHistory; track searchValue; let i = $index) {
          <div>
            <div
              class="history-wrapper cursor-pointer"
              (mouseover)="currentIndex = i; showCloseIcon=true"
              (focus)="currentIndex = i; showCloseIcon=true"
              (mouseout)="showCloseIcon = false; currentIndex = -1"
              (blur)="showCloseIcon = false; currentIndex = -1"
              [ngClass]="{'hover-bg-color': currentIndex === i}"
              (click)="searchTerms = searchValue;showResults()"
              >
              <mat-icon svgIcon="clock"></mat-icon>
              <span class="matomo_searchresults result-label">{{searchValue}}</span>
              <span
                class="delete-his-label"
                (click)="deleteSearchHistory(searchValue)"
                [style.visibility]="showCloseIcon && i === currentIndex ? 'visible' : 'hidden'"
                >
                <mat-icon
                  svgIcon="close-item-small"
                  class="close-item-small"
                ></mat-icon>
              </span>
            </div>
          </div>
        }
      }

      <!--*ngIf="searchTerms"-->
      @if (searchTerms) {
        @if (showLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
        }
        @if ((searchResult | async); as searchResults) {
          <!--contacts-->
          @if (displayResult(searchResults.contactOptions,GlobalSearchCategory.Contact)) {
            <div
              class="results-wrapper"
              >
              <mat-icon svgIcon="contacts"></mat-icon>
              <span class="result-label align-bottom">
                <b>{{ 'sharedNav.globalSearch.contacts' | transloco }}</b>
                <span class="pl-small">
                  ({{resultsCountText(searchResults?.contactsTotal ?? 0)}})
                  <a
                    (click)="navigateToViewAll(GlobalSearchCategory.Contact)"
                    class="highlight-color matomo_searchresults pl-medium"
                    >
                    {{ 'sharedNav.globalSearch.viewAll' | transloco }}
                  </a>
                </span>
              </span>
              @for (result of searchResults.contactOptions; track result) {
                <div
                  class="results-inner-wrapper"
                  >
                  <a
                    (click)="navigate('/contacts/contact/'+ result.id)"
                    class="highlight-color pr-medium"
                    >
                    <b>{{result.name}}</b>
                  </a>
                  <span class="matomo_searchresults pr-medium"
                    >{{ result.company }}
                  </span>
                  <button
                    (click)="makeCall(result.phoneId)"
                    class="pr-medium no-button-style"
                    [disabled]="makeCallInProgress"
                    >
                    {{result.phone}}
                  </button>
                  <a
                    class="highlight-color"
                    appMailTo="{{result.email}}"
                    >
                    {{ result.email }}
                  </a>
                </div>
              }
            </div>
          }
          <!--company-->
          @if (displayResult(searchResults.companyOptions,GlobalSearchCategory.Company)) {
            <div
              class="results-wrapper"
              >
              <mat-icon svgIcon="building"></mat-icon>
              <span class="result-label align-bottom">
                <b>{{ 'sharedNav.globalSearch.companies' | transloco }}</b>
                <span class="pl-small">
                  ({{resultsCountText(searchResults?.companiesTotal ?? 0)}})
                  <a
                    (click)="navigateToViewAll(GlobalSearchCategory.Company)"
                    class="matomo_searchresults highlight-color pl-medium"
                    >
                    {{ 'sharedNav.globalSearch.viewAll' | transloco }}
                  </a>
                </span>
              </span>
              @for (result of searchResults.companyOptions; track result) {
                <div
                  class="results-inner-wrapper"
                  >
                  <idl-has-highlights class="mg-rt" [hasHighlights]="result.hasHighlights"></idl-has-highlights>
                  <a
                    [href]="companyLink(result.id)"
                    target="_blank"
                    class="highlight-color pr-medium"
                    >
                    <b class="matomo_searchresults">{{result.name}}</b>
                  </a>
                  <span class="matomo_searchresults">
                    {{result.primaryAddress}}
                  </span>
                </div>
              }
            </div>
          }
          <!--deals-->
          @if (displayResult(searchResults.dealOptions,GlobalSearchCategory.Deal)) {
            <div
              class="results-wrapper"
              >
              <mat-icon svgIcon="deals"></mat-icon>
              <span class="result-label">
                <b>{{ 'sharedNav.globalSearch.deals' | transloco }}</b>
                <span class="pl-small">
                  ({{resultsCountText(searchResults?.dealsTotal ?? 0)}})
                  <a
                    (click)="navigateToViewAll(GlobalSearchCategory.Deal)"
                    class="matomo_searchresults highlight-color pl-medium"
                    >
                    {{ 'sharedNav.globalSearch.viewAll' | transloco }}
                  </a>
                </span>
              </span>
              @for (result of searchResults.dealOptions; track result) {
                <div
                  class="results-inner-wrapper"
                  >
                  <a
                    [href]="dealLink(result.id)"
                    target="_blank"
                    class="highlight-color pr-medium"
                    >
                    <b class="matomo_searchresults">{{result.name}}</b>
                  </a>
                  <span class="matomo_searchresults"
                    >{{result.propertyType}}, {{result.dealType}}, {{result.stage}},
                    {{result.entryDate}}</span
                    >
                  </div>
                }
              </div>
            }
            <!--property-->
            @if (displayResult(searchResults.propertyOptions,GlobalSearchCategory.Property)) {
              <div
                class="results-wrapper"
                >
                <mat-icon svgIcon="map-pin"></mat-icon>
                <span class="result-label">
                  <b>{{ 'sharedNav.globalSearch.properties' | transloco }}</b>
                  <span class="pl-small">
                    ({{resultsCountText(searchResults?.propertiesTotal ?? 0)}})
                    <a
                      (click)="navigateToViewAll(GlobalSearchCategory.Property)"
                      class="matomo_searchresults highlight-color pl-medium"
                      >
                      {{ 'sharedNav.globalSearch.viewAll' | transloco }}
                    </a>
                  </span>
                </span>
                @for (result of searchResults.propertyOptions; track result) {
                  <div
                    class="results-inner-wrapper"
                    >
                    <a
                      [href]="propertyLink(result.id)"
                      target="_blank"
                      class="highlight-color pr-medium"
                      >
                      <b class="matomo_searchresults">{{result.name}}</b>
                    </a>
                    <span class="matomo_searchresults">
                      {{result.propertyType}}, {{result.city}}, {{result.state}}
                    </span>
                  </div>
                }
              </div>
            }
            @if (!showLoading && !noResults) {
              <div
                class="show-more-wrapper"
                (click)="navigate()"
                >
                <a class="matomo_searchresults highlight-color">
                  {{ 'sharedNav.globalSearch.viewAllResultsFor' | transloco }} <q>{{searchTerms}}</q>
                  <mat-icon svgIcon="chevron-right"></mat-icon>
                </a>
              </div>
            }
          }
        }
        <!--when no data-->
        @if (noResults) {
          {{ 'sharedNav.globalSearch.noResults' | transloco }}
        }
      </div>
    </ng-template>
